<div class="creategame-modal">
  <div class="creategame-header">
    <h4>New Game</h4>
    <button type="button" class="creategame-close" aria-label="Close" (click)="closemodel()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <form [formGroup]="creategameform">
    <div class="form-group">
      <label for="game-name">Game Name</label>
      <input type="text" id="game-name" formControlName="Gamename" name="game-name" placeholder="Enter game name">
      @if (creategameform.get('Gamename')?.invalid && creategameform.get('Gamename')?.touched) {
        <div class="error-message">
          @if (creategameform.get('Gamename')?.errors?.['required']) {
            <div>Game Name is required</div>
          }
        </div>
      }
    </div>

    <div class="map-wrapper mb-3" style="height: 300px;">
      <div id="map" class="h-100" #map></div>
    </div>

    <div class="form-group">
      <label for="map-list">
        Map List
        @if (creategameform.get('map_id').invalid && creategameform.get('map_id').touched) {
          <span class="required-marker">*</span>
        }
      </label>
      <ng-select class="wt-select" id="map-list" formControlName="map_id" [items]="maplist"
        bindValue="map_id" bindLabel="map_name" placeholder="Choose…" [clearable]="false" appendTo="body">
        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.map_name }}</span></ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <label for="game-type">Game Type</label>
      <ng-select class="wt-select" id="game-type" formControlName="game_type" [items]="gametypelistdata"
        bindValue="value" bindLabel="value" placeholder="Choose…" [clearable]="false" appendTo="body">
        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <label for="game-system">Game System</label>
      <ng-select class="wt-select" id="game-system" formControlName="game_system" [items]="gamesystemlistdata"
        bindValue="value" bindLabel="value" placeholder="Choose…" [clearable]="false" appendTo="body">
        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
      </ng-select>
    </div>

    <button type="submit" class="btn btn-theme creategame-submit" (click)="submit(); creategameform.markAllAsTouched()">Submit</button>
  </form>
</div>
